import { useQuery } from "@tanstack/react-query";
import autoAssignService from "../../../../services/web/auto-assign-service";

function mapResponse(root) {
    const rows = Array.isArray(root) ? root : (Array.isArray(root?.content) ? root.content : []);
    return { rows };
}

export function useAutoAssignListQuery() {
    return useQuery({
        queryKey: ["autoAssignPlate"],
        queryFn: async () => {
            const data = await autoAssignService.list();
            return mapResponse(data);
        },
    });
}